module.exports = __webpack_public_path__ + "static/media/card-bronze.80bb1d01.png";